export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  NotSpecified = 'NOT_SPECIFIED',
}

export enum Role {
  SuperAdmin = 'SuperAdmin',
  SuffixAdmin = 'SuffixAdmin',
  SuffixAgent = 'SuffixAgent',
  Accountant='Accountant',
}
type userMenu = {
  id:string ;
  menu:string ;
  isPermission:boolean ;
}

export type User = {
  created_at: string;
  email: string | null;
  name: string;
  gender: Gender | null;
  id: string;
  is_active: boolean;
  last_name: string;
  phone_number: string;
  role: Role;
  address?:string;
  Menus?:userMenu[] ;
  profile_picture?:string ;
  user_id?:number ;
  role_type:string;
  rolePermission:any
};
export type PermissionFlags = {
  add: boolean;
  delete: boolean;
  edit: boolean;
  view: boolean;
  print: boolean;
};

export type LoginUserRolePermission = {
  menuId: number;
  menuKey: string;
  permissions: PermissionFlags;
};

export type Volunteer = {
  Id:string ;
  EventId:string ;
  EventName:string ;
  UserId:string ;
  Name:string;
  Email:string;
  PhoneNo:string;
  Status:boolean;
  IsRefundAllowed:boolean;
  CreatedDate:string;
}
export interface ProtectedRouteProps {
  pageKey: string;
  required: keyof PermissionFlags;
  children: React.ReactNode;
  redirectPath:string
}

      
      